// extracted by mini-css-extract-plugin
module.exports = {"OnlineStoreRightsA5":"OnlineStoreRightsA5_OnlineStoreRightsA5__UmGBu"};